import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Messages from 'spark-types/Messages';
import {
    newMessageExists,
    getCurrentMessage,
    closeMessage
} from 'spark-state/common/messages/messagesReducer';
import SuccessMessage from 'spark-ui/Messages/SuccessMessage';
import AlertMessage from 'spark-ui/Messages/AlertMessage';

const MessageListener = () => {
    const dispatch = useDispatch();
    const messageState = useSelector(state => {
        if (newMessageExists(state)) {
            const currentMessage = getCurrentMessage(state);
            return {
                message: currentMessage.text,
                messageType: currentMessage.messageType,
                messageValue: currentMessage.messageValue
            };
        }
        return {};
    });
    const { message, messageType, messageValue } = messageState;
    const onClose = () => dispatch(closeMessage());

    return (
        <React.Fragment>
            <SuccessMessage
                message={message}
                onClose={onClose}
                open={!!message && messageType === Messages.SUCCESS}
                messageValue = {messageValue}
            />
            <AlertMessage
                message={message}
                onClose={onClose}
                open={!!message && messageType === Messages.ALERT}
                messageValue = {messageValue}
            />
        </React.Fragment>
    );
};

export default MessageListener;
